import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@design-lab/app";

function init() {
  let container = document.querySelector(".js-design-lab");

  if (!container) {
    container = document.createElement("div");
    document.body.appendChild(container);
  }

  // Read config from data attribute
  const configData = container.getAttribute("data-config");
  const config = configData ? JSON.parse(configData) : {};

  createRoot(container).render(
    <StrictMode>
      <App config={config} />
    </StrictMode>
  );
}

document.addEventListener("DOMContentLoaded", () => {
  init();
});
